module.exports = (__webpack_require__(7))(538);


//////////////////
// WEBPACK FOOTER
// delegated ./node_modules/css-loader/lib/css-base.js from dll-reference vendor
// module id = 28
// module chunks = 1